<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Dashboard</h1>
    </div>

    <button type="button" class="btn btn-primary" v-on:click="sync()">{{ syncStatus }}</button>
    <button type="button" class="btn btn-secondary" v-on:click="log()">Log</button>

  </div><br><br>

    <div class="col">

    <div class="card-deck dash-container">

    <div class="card text-white bg-secondary mb-3">
      <div class="card-header">Products (API)</div>
      <div class="card-body">
        <h5 class="card-title">{{ apiProducts }}</h5>
      </div>
    </div>

    <div class="card text-white bg-success mb-3">
      <div class="card-header">Products (WooCommerce)</div>
      <div class="card-body">
        <h5 class="card-title">{{ wcProducts }}</h5>
      </div>
    </div>

    <div class="card text-white bg-danger mb-3">
      <div class="card-header">Products (Inactive)</div>
      <div class="card-body">
        <h5 class="card-title">{{ inactiveProducts }}</h5>
      </div>
    </div>

  </div>

  </div>

  <!-- Modal -->
  <div class="modal fade" id="logModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Log</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ logContent }}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>

import $ from 'jquery';
import axios from 'axios';

export default {
  name: 'app',
  components: {

  },
  data() {
    return{
      syncStatus: 'Sync',
      wcProducts: 0,
      apiProducts: 0,
      inactiveProducts: 0,
      logContent: ''
    }
  },
  mounted (){
    this.loadItems();
  },
  methods: {
    log(){
      axios
        .get('https://wrc.weblion.be/shop-api/wc-local/log.txt')
        .then((res) => {
          this.logContent = res.data;
        })
      $("#logModal").modal('show');
    },
    loadItems(){
      axios
        .get('https://wrc.weblion.be/shop-api/wc-local/dashboard.php')
        .then((res) => {
          this.wcProducts = res.data.wc;
          this.apiProducts = res.data.api;
        })
    },
    sync(){

      this.syncStatus = 'Syncing...';

      axios
        .get('https://wrc.weblion.be/shop-api/wc-local/fix_product_woo.php')
        .then((res) => {

          console.log(res);
          axios
          .get('https://wrc.weblion.be/resize.php')
          .then((res) => {

            console.log(res);
            axios
            .get('https://wrc.weblion.be/shop-api/wc-local/create_products.php')
            .then((res) => {

              console.log(res);
              axios
              .post('https://wrc.weblion.be/shop-api/wc-local/create_product_variations.php',
              {
                cvp: res.data
              })
              .then((res) => {

                console.log(res);
                axios
                .get('https://wrc.weblion.be/shop-api/wc-local/update_products.php')
                .then((res) => {

                  console.log(res);
                  axios
                    .get('https://wrc.weblion.be/shop-api/wc-local/fix_product_woo.php')
                    .then((res) => {

                      console.log(res);
                      axios
                        .get('https://wrc.weblion.be/shop-api/wc-local/create_related.php')
                        .then((res) => {
                          console.log(res);
                          this.syncStatus = 'Synced';
                      })

                  })

                })

              })

            })

        })

    })

    }
  }
}
</script>

<style>
.dash-container{
  padding: 100px 10px;
}
</style>
